import { render, staticRenderFns } from "./gj-info-modal.vue?vue&type=template&id=611e7377&scoped=true&"
import script from "./gj-info-modal.vue?vue&type=script&lang=js&"
export * from "./gj-info-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-info-modal.vue?vue&type=style&index=0&id=611e7377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e7377",
  null
  
)

export default component.exports